export default "__VITE_PUBLIC_ASSET__04b4b3a8__"